import {
  createContainer,
  InjectionMode,
  asFunction,
  asClass,
  asValue,
  Constructor,
  BuildResolverOptions,
  Resolver,
  AwilixContainer
} from "awilix";
import IModuleContainer from "./IModuleContainer";
import Application from "../Application";
import Store from "../model/runtime/state/Store";
import Dispatcher from "../model/runtime/state/Dispatcher";
import { UserPreferences } from "../common/Constants";
import { InMemoryCacheManager } from "../model/runtime/cache/InMemoryCacheManager";
import CachingHttpService from "../service/CachingHttpService";
import HttpService from "../service/HttpService";
import TranslationService from "../service/locale/TranslationService";
import HomeArea from "../areas/HomeArea";
import StorageService from "../service/StorageService";
import CryptographyService from "../service/cryptography/CryptographyService";
import CryptographyProvider from "../model/security/CryptographyProvider";
import RandomValueProvider from "../model/security/RandomValueProvider";
import CookieStorageService from "../service/CookieStorageService";
import InteractorProxy from "../interactor/InteractorProxy";
import ShowHomeInteractor from "../interactor/main/ShowHomeInteractor";
import RoleTypeService from "../service/role/RoleTypeService";
import ShowRoleTypesInteractor from "../interactor/roles/ShowRoleTypesInteractor";
import CodebookArea from "../areas/CodebookArea";
import GetRoleTypesInteractor from "../interactor/roles/GetRoleTypesInteractor";
import CreateRoleTypeInteractor from "../interactor/roles/CreateRoleTypeInteractor";
import UpdateRoleTypeInteractor from "../interactor/roles/UpdateRoleTypeInteractor";
import NotificationService from "../service/notification/NotificationService";
import ShowSuccessMessageInteractor from "../interactor/notifications/ShowSuccessMessageInteractor";
import ShowErrorMessageInteractor from "../interactor/notifications/ShowErrorMessageInteractor";
import ShowWarningMessageInteractor from "../interactor/notifications/ShowWarningMessageInteractor";
import ShowInfoMessageInteractor from "../interactor/notifications/ShowInfoMessageInteractor";
import GetReportingTypesInteractor from "../interactor/reporting/GetReportingTypesInteractor";
import GetRoleTypeReportingTypesInteractor from "../interactor/roles/GetRoleTypeReportingTypesInteractor";
import CreateRoleTypeReportingTypesInteractor from "../interactor/roles/CreateRoleTypeReportingTypesInteractor";
import RemoveRoleTypeReportingTypeInteractor from "../interactor/roles/RemoveRoleTypeReportingTypesInteractor";
import GetPositionTypesInteractor from "../interactor/position/GetPositionTypesInteractor";
import ApplicantService from "../service/applicant/ApplicantService";
import ShowRegisteredApplicantsInteractor from "../interactor/applicants/ShowRegisteredApplicantsInteractor";
import ApplicantsArea from "../areas/ApplicantsArea";

import GetApplicantsAppointmentsInteractor from "../interactor/applicants/GetApplicantsAppointmentsInteractor";
import CreateApplicantsAppointmentInteractor from "../interactor/applicants/CreateApplicantsAppointmentInteractor";
import UpdateApplicantsAppointmentInteractor from "../interactor/applicants/UpdateApplicantsAppointmentInteractor";
import PositionTypeService from "../service/position/PositionTypeService";
import RemoveRoleTypePositionTypesInteractor from "../interactor/roles/RemoveRoleTypePositionTypesInteractor";
import CreateRoleTypePositionTypesInteractor from "../interactor/roles/CreateRoleTypePositionTypesInteractor";
import GetRoleTypePositionTypesInteractor from "../interactor/roles/GetRoleTypePositionTypesInteractor";
import ShowPositionTypesInteractor from "../interactor/position/ShowPositionTypesInteractor";
import CreatePositionInteractor from "../interactor/position/CreatePositionTypeInteractor";
import UpdatePositionTypeInteractor from "../interactor/position/UpdatePositionTypeInteractor";
import ReportingTypeService from "../service/reporting/ReportingTypeService";
import GetReportingTypeInteractor from "../interactor/reporting/GetReportingTypeInteractor";
import CreateReportingTypeInteractor from "../interactor/reporting/CreateReportingTypeInteractor";
import UpdateReportingTypeInteractor from "../interactor/reporting/UpdateReportingTypeInteractor";

import ShowReportingPeriodPermissionsInteractor from "../interactor/reporting/ShowReportingPeriodPermissionsInteractor";
import CreateReportingPeriodPermissionInteractor from "../interactor/reporting/CreateReportingPeriodPermissionInteractor";
import GetReportingPeriodPermissionsInteractor from "../interactor/reporting/GetReportingPeriodPermissionsInteractor";
import UpdateReportingPeriodPermissionInteractor from "../interactor/reporting/UpdateReportingPeriodPermissionInteractor";
import ReportingPeriodService from "../service/reporting/ReportingPeriodService";
import ShowReportingPeriodsInteractor from "../interactor/reporting/ShowReportingPeriodsInteractor";
import CreateReportingPeriodInteractor from "../interactor/reporting/CreateReportingPeriodInteractor";
import UpdateReportingPeriodInteractor from "../interactor/reporting/UpdateReportingPeriodInteractor";
import GetReportingPeriodsInteractor from "../interactor/reporting/GetReportingPeriodsInteractor";
import ShowLoginInteractor from "../interactor/authentication/ShowLoginInteractor";
import AuthenticationArea from "../areas/AuthenticationArea";
import AuthenticationService from "../service/authentication/AuthenticationService";
import LoginInteractor from "../interactor/authentication/LoginInteractor";
import LogoutInteractor from "../interactor/authentication/LogoutInteractor";
import CredentialsService from "../service/authentication/CredentialsService";
import CheckLoginStatusInteractor from "../interactor/authentication/CheckLoginStatusInteractor";
import LoadUserPreferencesInteractor from "../interactor/authentication/LoadUserPreferencesInteractor";
import ReportingArea from "../areas/ReportingArea";
import GetFormTypesInteractor from "../interactor/formconfiguration/GetFormTypesInteractor";
import CreateFormTypeInteractor from "../interactor/formconfiguration/CreateFormTypeInteractor";
import UpdateFormTypeInteractor from "../interactor/formconfiguration/UpdateFormTypeInteractor";
import ShowFormTypesInteractor from "../interactor/formconfiguration/ShowFormTypesInteractor";
import CreateFormTypesGroupCategoryInteractor from "../interactor/formconfiguration/CreateFormTypesGroupCategoryInteractor";
import GetFormTypesGroupCategoriesInteractor from "../interactor/formconfiguration/GetFormTypesGroupCategoriesInteractor";
import UpdateFormTypesGroupCategoryInteractor from "../interactor/formconfiguration/UpdateFormTypesGroupCategoryInteractor";
import ShowFormTypesGroupCategoriesInteractor from "../interactor/formconfiguration/ShowFormTypesGroupCategoriesInteractor";
import GetFormTypesGroupsInteractor from "../interactor/formconfiguration/GetFormTypesGroupsInteractor";
import CreateFormTypesGroupsInteractor from "../interactor/formconfiguration/CreateFormTypesGroupsInteractor";
import RemoveFormTypesGroupsInteractor from "../interactor/formconfiguration/RemoveFormTypesGroupsInteractor";
import ShowFormConfigurationInteractor from "../interactor/formconfiguration/ShowFormConfigurationInteractor";
import CreateFormSectionInteractor from "../interactor/formconfiguration/CreateFormSectionInteractor";
import UpdateFormSectionInteractor from "../interactor/formconfiguration/UpdateFormSectionInteractor";
import GetFormTypeInteractor from "../interactor/formconfiguration/GetFormTypeInteractor";
import InvalidateFormSectionInteractor from "../interactor/formconfiguration/InvalidateFormSectionInteractor";
import CreateAttributeInteractor from "../interactor/formconfiguration/CreateAttributeInteractor";
import UpdateAttributeInteractor from "../interactor/formconfiguration/UpdateAttributeInteractor";
import InvalidateAttributeInteractor from "../interactor/formconfiguration/InvalidateAttributeInteractor";
import CreateQualifierInteractor from "../interactor/formconfiguration/CreateQualifierInteractor";
import UpdateQualifierInteractor from "../interactor/formconfiguration/UpdateQualifierInteractor";
import InvalidateQualifierInteractor from "../interactor/formconfiguration/InvalidateQualifierInteractor";
import UserService from "../service/user/UserService";
import ChangePasswordInteractor from "../interactor/authentication/ChangePasswordInteractor";
import ShowSettingsInteractor from "../interactor/settings/ShowSettingsInteractor";
import SettingsArea from "../areas/SettingsArea";
import ShowChangePasswordInteractor from "../interactor/authentication/ShowChangePasswordInteractor";
import ShowRegisteredApplicantDetailsInteractor from "../interactor/applicants/ShowRegisteredApplicantDetailsInteractor";
import ShowReportingTypesInteractor from "../interactor/reporting/ShowReportingTypesInteractor";
import MikPortalArea from "../areas/MikPortalArea";
import FrontOfficeHomeArea from "../areas/FrontOfficeHomeArea";
import ShowFrontOfficeHomeInteractor from "../interactor/main/ShowFrontOfficeHomeInteractor";
import GetReportingPeriodFormTypesInteractor from "../interactor/reporting/GetReportingPeriodFormTypesInteractor";
import CopyFormTypeInteractor from "../interactor/formconfiguration/CopyFormTypeInteractor";

import MenuItemService from "../service/menu/MenuItemService";
import GetAllRootMenuItemsInteractor from "../interactor/menu/GetAllRootMenuItemsInteractor";
import GetAvailableMenuItemsInteractor from "../interactor/menu/GetAvailableMenuItemsInteractor";
import CreateMenuItemInteractor from "../interactor/menu/CreateMenuItemInteractor";
import UpdateMenuItemInteractor from "../interactor/menu/UpdateMenuItemInteractor";
import ShowMenuItemsInteractor from "../interactor/menu/ShowMenuItemsInteractor";

import FormArea from "../areas/FormArea";
import ShowFormDetailsInteractor from "../interactor/form/ShowFormDetailsInteractor";
import FormTypeService from "../service/formconfiguration/FormTypeService";
import FormSectionService from "../service/formconfiguration/FormSectionService";
import QualifierService from "../service/formconfiguration/QualifierService";
import AttributeService from "../service/formconfiguration/AttributeService";
import FormTypesGroupCategoryService from "../service/formconfiguration/FormTypesGroupCategoryService";
import FormService from "../service/form/FormService";
import FactService from "../service/evaluation/FactService";
import GetFactsInteractor from "../interactor/evaluation/GetFactsInteractor";
import ShowFactsInteractor from "../interactor/evaluation/ShowFactsInteractor";
import CreateFactInteractor from "../interactor/evaluation/CreateFactInteractor";
import UpdateFactInteractor from "../interactor/evaluation/UpdateFactInteractor";
import BusinessRuleService from "../service/evaluation/BusinessRuleService";
import GetBusinessRulesInteractor from "../interactor/evaluation/GetBusinessRulesInteractor";
import ShowBusinessRulesInteractor from "../interactor/evaluation/ShowBusinessRulesInteractor";
import CreateBusinessRuleInteractor from "../interactor/evaluation/CreateBusinessRuleInteractor";
import UpdateBusinessRuleInteractor from "../interactor/evaluation/UpdateBusinessRuleInteractor";
import GetFormDetailsInteractor from "../interactor/form/GetFormDetailsInteractor";
import GetReferenceValueListInteractor from "../interactor/form/GetReferenceValueListInteractor";
import GetFormVersionsInteractor from "../interactor/form/GetFormVersionsInteractor";
import ChangeFormAttributeInteractor from "../interactor/form/ChangeFormAttributeInteractor";
import SendFormVersionInteractor from "../interactor/form/SendFormVersionInteractor";
import DeleteDraftVersionFormInteractor from "../interactor/form/DeleteDraftVersionFormInteractor";
import AddRowInteractor from "../interactor/form/AddRowInteractor";
import DeleteRowInteractor from "../interactor/form/DeleteRowInteractor";
import UndoRowDeleteInteractor from "../interactor/form/UndoRowDeleteInteractor";
import SystemParameterService from "../service/systemparameter/SystemParameterService";
import GetSystemParametersInteractor from "../interactor/systemparameter/GetSystemParametersInteractor";
import RemoveSystemParametersInteractor from "../interactor/systemparameter/RemoveSystemParametersInteractor";
import ShowSystemParametersInteractor from "../interactor/systemparameter/ShowSystemParametersInteractor";
import CreateSystemParameterInteractor from "../interactor/systemparameter/CreateSystemParameterInteractor";
import UpdateSystemParameterInteractor from "../interactor/systemparameter/UpdateSystemParameterInteractor";
import ShowFormsInteractor from "../interactor/form/ShowFormsInteractor";
import GetReportingPeriodsByApplicantIdInteractor from "../interactor/form/GetReportingPeriodsByApplicantIdInteractor";
import AddNewDraftFormVersionInteractor from "../interactor/form/AddNewDraftFormVersionInteractor";
import RuleGroupService from "../service/evaluation/RuleGroupService";
import GetRuleGroupsInteractor from "../interactor/evaluation/GetRuleGroupsInteractor";
import ShowRuleGroupsInteractor from "../interactor/evaluation/ShowRuleGroupsInteractor";
import CreateRuleGroupInteractor from "../interactor/evaluation/CreateRuleGroupInteractor";
import UpdateRuleGroupInteractor from "../interactor/evaluation/UpdateRuleGroupInteractor";
import GetRuleGroupElementsInteractor from "../interactor/evaluation/GetRuleGroupElementsInteractor";
import AddBusinessRuleToRuleGroupInteractor from "../interactor/evaluation/AddBusinessRuleToRuleGroupInteractor";
import RemoveBusinessRuleFromRuleGroupInteractor from "../interactor/evaluation/RemoveBusinessRuleFromRuleGroupInteractor";
import EvaluationTypeService from "../service/evaluation/EvaluationTypeService";
import GetEvaluationTypesInteractor from "../interactor/evaluation/GetEvaluationTypesInteractor";
import ShowEvaluationTypesInteractor from "../interactor/evaluation/ShowEvaluationTypesInteractor";
import CreateEvaluationTypeInteractor from "../interactor/evaluation/CreateEvaluationTypeInteractor";
import UpdateEvaluationTypeInteractor from "../interactor/evaluation/UpdateEvaluationTypeInteractor";
import AssignApplicantsToReportingPeriodInteractor from "../interactor/reporting/AssignApplicantsToReportingPeriodInteractor";
import RequestService from "../service/request/RequestService";
import GetRequestTypesInteractor from "../interactor/requests/GetRequestTypesInteractor";
import CreateRequestTypeInteractor from "../interactor/requests/CreateRequestTypeInteractor";
import CreateRequestInteractor from "../interactor/requests/CreateRequestInteractor";
import UpdateRequestTypeInteractor from "../interactor/requests/UpdateRequestTypeInteractor";
import ShowRequestTypesInteractor from "../interactor/requests/ShowRequestTypesInteractor";
import GetApplicantRequestsInteractor from "../interactor/requests/GetApplicantRequestsInteractor";
import GetApplicantReportingPeriodsInteractor from "../interactor/applicants/GetApplicantReportingPeriodsInteractor";
import ShowPortalReportingPeriodInteractor from "../interactor/portal/ShowPortalReportingPeriodInteractor";
import ShowPortalFormDetailsInteractor from "../interactor/portal/ShowPortalFormDetailsPageInteractor";
import GetReportingPeriodApplicantsInteractor from "../interactor/portal/GetReportingPeriodApplicantsInteractor";
import GetPortalFormsInteractor from "../interactor/portal/GetPortalFormsInteractor";
import LoadMenuItemsInteractor from "../interactor/portal/LoadMenuItemsInteractor";
import ShowPortalHomeInteractor from "../interactor/main/ShowPortalHomeInteractor";
import PortalReportingArea from "../areas/PortalReportingArea";
import PortalReportingPeriodService from "../service/reporting/PortalReportingPeriodService";
import NoticeService from "../service/notice/NoticeService";
import UpdateRequestInteractor from "../interactor/requests/UpdateRequestInteractor";
import ShowReportingPeriodDetailsInteractor from "../interactor/reporting/ShowReportingPeriodDetailsInteractor";
import ShowInfoNotificationBoxInteractor from "../interactor/notifications/ShowInfoNotificationBoxInteractor";
import GetBoFormTypesInteractor from "../interactor/form/GetBoFormTypesInteractor";
import GetBoFormVersionsInteractor from "../interactor/form/GetBoFormVersionsInteractor";
import EvaluationService from "../service/evaluation/EvaluationService";
import GetEvaluationsInteractor from "../interactor/evaluation/GetEvaluationsInteractor";
import ShowReportingPeriodApplicantDocumentsInteractor from "../interactor/reporting/ShowReportingPeriodApplicantDocumentsInteractor";
import UploadDocumentInteractor from "../interactor/document/UploadDocumentInteractor";
import UpdateDocumentInteractor from "../interactor/document/UpdateDocumentInteractor";
import ShowApplicantFormDetailsInteractor from "../interactor/applicants/ShowApplicantFormDetailsInteractor";
import ApplicantFormService from "../service/form/ApplicantFormService";
import MarkForAdditionalCheckInteractor from "../interactor/applicants/MarkForAdditionCheckInteractor";
import UpdateStatusOfAdditionalCheckInteractor from "../interactor/applicants/UpdateStatusOfAdditionalCheckInteractor";
import SetFormVersionForAnnouncementInteractor from "../interactor/applicants/SetFormVersionForAnnouncementInteractor";
import GetIsSignedReportRequiredForAnnouncementInteractor from "../interactor/applicants/GetIsSignedReportRequiredForAnnouncementInteractor";
import GetRequestsInteractor from "../interactor/requests/GetRequestsInteractor";
import RequestsArea from "../areas/RequestsArea";
import MarkRequestReadInteractor from "../interactor/requests/MarkRequestReadInteractor";
import ShowRequestsInteractor from "../interactor/requests/ShowRequestsInteractor";
import UpdateBusinessRuleInRuleGroupInteractor from "../interactor/evaluation/UpdateBusinessRuleInRuleGroupInteractor";
import GetDataReport5Interactor from "../interactor/report/GetDataReport5Interactor";
import GetDataReport4Interactor from "../interactor/report/GetDataReport4Interactor";
import ReportsArea from "../areas/ReportsArea";
import ReportService from "../service/report/ReportService";
import LanguageService from "../service/language/LanguageService";
import ChangeLanguageInteractor from "../interactor/settings/ChangeLanguageInteractor";
import GetAuthorizedOperatorsInteractor from "../interactor/reporting/GetAuthorizedOperatorsInteractor";
import UpdateElectronicRegistryNumberInteractor from "../interactor/applicants/UpdateElectronicRegistryNumberInteractor";
import ShowFormVersionEvaluationsInteractor from "../interactor/evaluation/ShowFormVersionEvaluationsInteractor";
import ExecuteReportEvaluationInteractor from "../interactor/evaluation/ExecuteReportEvaluationInteractor";
import ShowEvaluationPageInteractor from "../interactor/evaluation/ShowEvaluationPageInteractor";
import EvaluationsArea from "../areas/EvaluationsArea";
import GetEvaluationRuleGroups from "../interactor/evaluation/GetEvaluationRuleGroupsInteractor";
import GetReport3DataInteractor from "../interactor/report/GetReport3DataInteractor";
import ShowReport5PageInteractor from "../interactor/report/ShowReport5PageInteractors";
import GetRiskCriteriaInteractor from "../interactor/report/GetRiskCriteriaInteractor";
import ValidateFormInteractor from "../interactor/form/ValidateFormInteractor";
import ShowAttributeCodebookInteractor from "../interactor/valuelist/ShowAttributeCodebookInteractor";
import GetAttributeReferenceListInteractor from "../interactor/valuelist/GetAttributeReferenceListInteractor";
import ReleaseRuleGroupFromEvaluationTypeInteractor from "../interactor/evaluation/ReleaseRuleGroupFromEvaluationTypeInteractor";
import JoinRuleGroupToEvaluationTypeInteractor from "../interactor/evaluation/JoinRuleGroupToEvaluationTypeInteractor";
import GetEvaluationTypeRuleGroupsInteractor from "../interactor/evaluation/GetEvaluationTypeRuleGroupsInteractor";
import ShowReport3PageInteractor from "../interactor/report/ShowReport3PageInteractor";
import GetReport2DataInteractor from "../interactor/report/GetReport2DataInteractor";
import ShowReport2PageInteractor from "../interactor/report/ShowReport2PageInteractor";
import ShowReport4PageInteractor from "../interactor/report/ShowReport4PageInteractor";
import AddBONewDraftFormVersionInteractor from "../interactor/applicants/AddBONewDraftFormVersionInteractor";
import GetDataReport8Interactor from "../interactor/report/GetDataReport8Interactor";
import ShowReport8PageInteractor from "../interactor/report/ShowReport8PageInteractor";
import CheckRightOfAccessToDataInteractor from "../interactor/form/CheckRightOfAccessToDataInteractor";
import ValueListService from "../service/valuelist/ValueListService";
import UpdateAttributeReferenceInteractor from "../interactor/valuelist/UpdateAttributeReferenceInteractor";
import CreateAttributeReferenceInteractor from "../interactor/valuelist/CreateAttribtueReferenceInteractor";
import DeleteAttributeReferenceListInteractor from "../interactor/valuelist/DeleteAttributeReferenceListInteractor";
import GetAttributeCodeListInteractor from "../interactor/valuelist/GetAttributeCodeListInteractor";
import DeleteAttributeReferenceInteractor from "../interactor/valuelist/DeleteAttributeReferenceInteractor";
import ShowReport6PageInteractor from "../interactor/report/ShowReport6PageInteractor";
import JoinEvaluationTypeToFormTypeInteractor from "../interactor/formconfiguration/JoinEvaluationTypeToFormTypeInteractor";
import RemoveEvaluationTypeFromFormTypeInteractor from "../interactor/formconfiguration/RemoveEvaluationTypeFromFormTypeInteractor";
import GetFormTypeEvaluationsInteractor from "../interactor/formconfiguration/GetFormTypeEvaluationsInteractor";
import ShowVerificationPageInteractor from "../interactor/authentication/ShowVerificationPageInteractor";
import GetEvaluationBusinessRulesInteractor from "../interactor/evaluation/GetEvaluationBusinessRulesInteractor";
import GetReport6DataInteractors from "../interactor/report/GetReport6DataInteractors";
import GetDataReport1Interactor from "../interactor/report/GetDataReport1Interactor";
import ShowReport1PageInteractor from "../interactor/report/ShowReport1PageInteractor";
import GetFormTypeListInteractor from "../interactor/report/GetFormTypeListInteractor";
import GetReport1FormVersionListInteractor from "../interactor/report/GetReport1FormVersionListInteractor";
import GetReport1ApplicantsInteractor from "../interactor/report/GetReport1ApplicantsInteractor";
import GetApplicantsInteractor from "../interactor/report/GetApplicantsInteractor";
import GetReport8ApplicantsInteractor from "../interactor/report/GerReport8ApplicantsInteractor";
import GetRolesInteractor from "../interactor/authentication/GetRolesInteractor";
import DynamicQueryService from "../service/dynamicQuery/DynamicQueryService";
import GetDynamicQueriesInteractor from "../interactor/dynamicQuery/GetDynamicQueriesInteractor";
import CreateDynamicQueryInteractor from "../interactor/dynamicQuery/CreateDynamicQueryInteractor";
import UpdateDynamicQueryInteractor from "../interactor/dynamicQuery/UpdateDynamicQueryInteractor";
import DeleteDynamicQueryInteractor from "../interactor/dynamicQuery/DeleteDynamicQueryInteractor";
import ShowDynamicQueriesInteractor from "../interactor/dynamicQuery/ShowDynamicQueriesInteractor";
import SetFormalCheckStatusInteractor from "../interactor/form/SetFormalCheckStatusInteractor";
import AsyncLocaleProvider from "../service/locale/AsyncLocaleProvider";
import GetSelectedLanguageInteractor from "../interactor/settings/GetSelectedLanguageInteractor";
import LoadLanguagesInteractor from "../interactor/portal/LoadLanguagesInteractor";
import LoadApplicationInteractor from "../interactor/portal/LoadApplicationInteractor";
import PortalMenuItemService from "../service/menu/PortalMenuItemService";
import CreateNewFormVersionInteractor from "../interactor/formconfiguration/CreateNewFormVersionInteractor";
import PublishFormVersionInteractor from "../interactor/formconfiguration/PublishFormVersionInteractor";
import CancelFormVersionInteractor from "../interactor/formconfiguration/CancelFormVersionInteractor";
import GetFormReportInteractor from "../interactor/form/GetFormReportInteractor";
import UploadSignedReportInteractor from "../interactor/form/UploadSignedReportInteractor";
import ShowPublicationsReportPageInteractor from "../interactor/report/ShowPublicationsReportPageInteractor";
import GetAdditionalEvaluationResultInteractor from "../interactor/applicants/GetAdditionalEvaluationResultInteractor";
import UpdateAdditionalEvaluationResultInteractor from "../interactor/applicants/UpdateAdditionalEvaluationResultInteractor";
import ShowUnauthorizedMsgInteractor from "../interactor/authentication/ShowUnauthorizedMsgInteractor";
import IsAllowedRandomSelectionInteractor from "../interactor/reporting/IsAllowedRandomSelectionInteractor";
import GetSystemParameterNumberInteractor from "../interactor/systemparameter/GetSystemParameterNumberInteractor";
import SelectForAdditionalCheckInteractor from "../interactor/reporting/SelectForAdditionalCheckInteractor";
import ConfirmAdditionalCheckInteractor from "../interactor/reporting/ConfirmAdditionalCheckInteractor";
import ReportingPeriodApplicantDocumentService from "../service/document/ReportingPeriodApplicantDocumentService";
import GetReportingPeriodApplicantDocumentsInteractor from "../interactor/document/GetReportingPeriodApplicantDocumentsInteractor";
import RemoveReportingPeriodApplicantDocumentInteractor from "../interactor/document/RemoveReportingPeriodApplicantDocumentInteractor";
import AssignReportingPeriodApplicantDocumentInteractor from "../interactor/document/AssignReportingPeriodApplicantDocumentInteractor";
import ShowReport7PageInteractor from "../interactor/report/ShowReport7PageInteractor";
import GetFormStructureInteractor from "../interactor/report/GetFormStructureInteractor";
import GetReport7DataInteractor from "../interactor/report/GetReport7DataInteractor";
import FormConfigurationService from "../service/formconfiguration/FormConfigurationService";
import GetFormConfigDetailsInteractor from "../interactor/formconfiguration/GetFormConfigDetailsInteractor";
import CreateFormConfigSectionQualifierInteractor from "../interactor/formconfiguration/CreateFormConfigSectionQualifierInteractor";
import UpdateFormConfigSectionQualifierInteractor from "../interactor/formconfiguration/UpdateFormConfigSectionQualifierInteractor";
import CreateFormConfigQualifierAttributeInteractor from "../interactor/formconfiguration/CreateFormConfigQualifierAttributeInteractor";
import UpdateFormConfigQualifierAttributeInteractor from "../interactor/formconfiguration/UpdateFormConfigQualifierAttributeInteractor";
import ConfigurationService from "../service/config/ConfigurationService";
import ShowResetPasswordInteractor from "../interactor/authentication/ShowResetPasswordInteractor";
import ResetPasswordInteractor from "../interactor/authentication/ResetPasswordInteractor";
import RegisterApplicantInteractor from "../interactor/applicants/RegisterApplicantInteractor";
import GetRegisteredApplicants from "../interactor/applicants/GetRegisteredApplicantsInteractor";
import PortalReportingPeriodApplicantDocumentService from "../service/document/PortalReportingPeriodApplicantDocumentService";
import GetPortalReportingPeriodApplicantDocumentsInteractor from "../interactor/document/GetPortalReportingPeriodApplicantDocumentsInteractor";

//const DEFAULT_CACHE_TIMEOUT_MS = 15000;
const ModuleContainer = (application: Application): IModuleContainer => {
  const _application = application;
  const _container = createContainer({
    injectionMode: InjectionMode.CLASSIC
  });

  function withCache(moduleName: string, timeToLiveMs?: number) {
    return (c) => ({
      httpService: CachingHttpService(
        _container.resolve("http"),
        _container.resolve("cacheManager"),
        {
          name: moduleName,
          timeToLive: timeToLiveMs !== undefined ? timeToLiveMs : 0
        }
      )
    });
  }

  function asInteractor<T = {}>(
    Type: Constructor<T>,
    opts?: BuildResolverOptions<T>
  ): Resolver<T> {
    return {
      resolve: (container: AwilixContainer) => {
        var interactor = container.build(asClass(Type, opts));
        return new InteractorProxy(interactor, _application) as any as T;
      }
    };
  }

  const Config = process.env;
  _container.register({
    // config: asFunction(Configuration).singleton(),
    // configurationProvider: asFunction(
    //   EnvironmentConfigurationProvider
    // ).singleton(),
    application: asValue(_application),
    container: asValue(_container),
    baseUrl: asValue(Config.REACT_APP_API_URL),
    options: asValue(null),
    cacheManager: asFunction(InMemoryCacheManager).singleton(),
    language: asValue(UserPreferences.DEFAULT_LANGUAGE),
    localeProvider: asFunction(AsyncLocaleProvider).singleton(),
    dispatcher: asFunction(Dispatcher).singleton(),
    store: asFunction(Store)
      .singleton()
      .inject((c) => ({
        dispatcher: _container.resolve("dispatcher"),
        initialState: {},
        defaultTopic: "app"
      })),
    defaultSettings: asValue(Config)
  });

  //services
  _container.register({
    storageService: asFunction(StorageService),
    cookieStorageService: asFunction(CookieStorageService),
    httpService: asFunction(CachingHttpService),
    http: asFunction(HttpService),
    translationService: asFunction(TranslationService),
    cryptographyProvider: asFunction(CryptographyProvider),
    randomValueProvider: asFunction(RandomValueProvider),
    cryptographyService: asFunction(CryptographyService),
    roleTypeService: asFunction(RoleTypeService).inject(withCache("roleType")),
    notificationService: asFunction(NotificationService),
    formTypeService: asFunction(FormTypeService),
    formSectionService: asFunction(FormSectionService),
    qualifierService: asFunction(QualifierService),
    attributeService: asFunction(AttributeService),
    reportingTypeService: asFunction(ReportingTypeService).inject(
      withCache("reportingType")
    ),
    applicantService: asFunction(ApplicantService).inject(
      withCache("applicant")
    ),
    positionTypeService: asFunction(PositionTypeService).inject(
      withCache("position")
    ),
    reportingPeriodService: asFunction(ReportingPeriodService).inject(
      withCache("reportingPeriod")
    ),
    factService: asFunction(FactService).inject(withCache("fact")),
    businessRuleService: asFunction(BusinessRuleService).inject(
      withCache("business-rule")
    ),
    ruleGroupService: asFunction(RuleGroupService).inject(
      withCache("rule-group")
    ),
    evaluationTypeService: asFunction(EvaluationTypeService).inject(
      withCache("evaluation-type")
    ),
    authenticationService: asFunction(AuthenticationService).inject(
      withCache("authentication")
    ),
    credentialsService: asFunction(CredentialsService),
    formTypesGroupCategoryService: asFunction(
      FormTypesGroupCategoryService
    ).inject(withCache("formTypesGroupCategory")),
    userService: asFunction(UserService).inject(withCache("user")),
    menuItemService: asFunction(MenuItemService),
    formService: asFunction(FormService).inject(withCache("form")),
    requestService: asFunction(RequestService).inject(withCache("requestType")),
    systemParameterService: asFunction(SystemParameterService).inject(
      withCache("systemParameter")
    ),
    portalMenuItemService: asFunction(PortalMenuItemService).inject(
      withCache("portalMenuItem")
    ),
    portalReportingPeriodService: asFunction(
      PortalReportingPeriodService
    ).inject(withCache("portalReportingPeriod")),
    noticeService: asFunction(NoticeService).inject(withCache("notice")),
    evaluationService: asFunction(EvaluationService).inject(
      withCache("evaluation")
    ),
    applicantFormService: asFunction(ApplicantFormService).inject(
      withCache("applicantForm")
    ),
    reportService: asFunction(ReportService).inject(withCache("report")),
    languageService: asFunction(LanguageService).inject(
      withCache("languageService")
    ),
    valueListService: asFunction(ValueListService).inject(
      withCache("valueList")
    ),
    dynamicQueryService: asFunction(DynamicQueryService).inject(
      withCache("dynamicQuery")
    ),
    reportingPeriodApplicantDocumentService: asFunction(
      ReportingPeriodApplicantDocumentService
    ).inject(withCache("reportingPeriodApplicantDocument")),
    formConfigurationService: asFunction(FormConfigurationService).inject(
      withCache("formConfiguration")
    ),
    configurationService: asFunction(ConfigurationService).inject(
      withCache("configuration")
    ),
    portalReportingPeriodApplicantDocumentService: asFunction(
      PortalReportingPeriodApplicantDocumentService
    ).inject(withCache("portalReportingPeriodApplicantDocument"))
  });

  //areas
  _container.register({
    authenticationArea: asClass(AuthenticationArea).singleton(),
    homeArea: asClass(HomeArea).singleton(),
    mikPortalArea: asClass(MikPortalArea).singleton(),
    codebookArea: asClass(CodebookArea).singleton(),
    applicantsArea: asClass(ApplicantsArea).singleton(),
    reportingArea: asClass(ReportingArea).singleton(),
    settingsArea: asClass(SettingsArea).singleton(),
    frontOfficeHomeArea: asClass(FrontOfficeHomeArea).singleton(),
    formArea: asClass(FormArea).singleton(),
    portalReportingArea: asClass(PortalReportingArea).singleton(),
    requestsArea: asClass(RequestsArea).singleton(),
    reportsArea: asClass(ReportsArea).singleton(),
    evaluationsArea: asClass(EvaluationsArea).singleton()
  });

  //interactors
  _container.register({
    showHome: asInteractor(ShowHomeInteractor),
    showRoleTypes: asInteractor(ShowRoleTypesInteractor),
    getRoleTypes: asInteractor(GetRoleTypesInteractor),
    createRoleType: asInteractor(CreateRoleTypeInteractor),
    updateRoleType: asInteractor(UpdateRoleTypeInteractor),
    showSuccessMessage: asInteractor(ShowSuccessMessageInteractor),
    showErrorMessage: asInteractor(ShowErrorMessageInteractor),
    showWarningMessage: asInteractor(ShowWarningMessageInteractor),
    showInfoMessage: asInteractor(ShowInfoMessageInteractor),
    getReportingTypes: asInteractor(GetReportingTypesInteractor),
    getRoleTypeReportingTypes: asInteractor(
      GetRoleTypeReportingTypesInteractor
    ),
    createRoleTypeReportingTypes: asInteractor(
      CreateRoleTypeReportingTypesInteractor
    ),
    removeRoleTypeReportingTypes: asInteractor(
      RemoveRoleTypeReportingTypeInteractor
    ),
    showRegisteredApplicants: asInteractor(ShowRegisteredApplicantsInteractor),
    getApplicantsAppointments: asInteractor(
      GetApplicantsAppointmentsInteractor
    ),
    createApplicantsAppointment: asInteractor(
      CreateApplicantsAppointmentInteractor
    ),
    updateApplicantsAppointment: asInteractor(
      UpdateApplicantsAppointmentInteractor
    ),
    showPositionTypes: asInteractor(ShowPositionTypesInteractor),
    getPositionTypes: asInteractor(GetPositionTypesInteractor),
    getRoleTypePositionTypes: asInteractor(GetRoleTypePositionTypesInteractor),
    removeRoleTypePositionTypes: asInteractor(
      RemoveRoleTypePositionTypesInteractor
    ),
    createRoleTypePositionTypes: asInteractor(
      CreateRoleTypePositionTypesInteractor
    ),
    createPositionType: asInteractor(CreatePositionInteractor),
    updatePositionType: asInteractor(UpdatePositionTypeInteractor),
    showReportingTypes: asInteractor(ShowReportingTypesInteractor),
    getReportingType: asInteractor(GetReportingTypeInteractor),
    createReportingType: asInteractor(CreateReportingTypeInteractor),
    updateReportingType: asInteractor(UpdateReportingTypeInteractor),

    showReportingPeriodPermissions: asInteractor(
      ShowReportingPeriodPermissionsInteractor
    ),
    createReportingPeriodPermission: asInteractor(
      CreateReportingPeriodPermissionInteractor
    ),
    getReportingPeriodPermissions: asInteractor(
      GetReportingPeriodPermissionsInteractor
    ),
    updateReportingPeriodPermission: asInteractor(
      UpdateReportingPeriodPermissionInteractor
    ),
    showReportingPeriods: asInteractor(ShowReportingPeriodsInteractor),
    createReportingPeriod: asInteractor(CreateReportingPeriodInteractor),
    updateReportingPeriod: asInteractor(UpdateReportingPeriodInteractor),
    getReportingPeriods: asInteractor(GetReportingPeriodsInteractor),
    getFormTypes: asInteractor(GetFormTypesInteractor),
    createFormType: asInteractor(CreateFormTypeInteractor),
    updateFormType: asInteractor(UpdateFormTypeInteractor),
    showFormTypes: asInteractor(ShowFormTypesInteractor),
    createFormTypesGroupCategory: asInteractor(
      CreateFormTypesGroupCategoryInteractor
    ),
    getFormTypesGroupCategories: asInteractor(
      GetFormTypesGroupCategoriesInteractor
    ),
    updateFormTypesGroupCategory: asInteractor(
      UpdateFormTypesGroupCategoryInteractor
    ),
    showFormTypesGroupCategories: asInteractor(
      ShowFormTypesGroupCategoriesInteractor
    ),
    getFormTypesGroups: asInteractor(GetFormTypesGroupsInteractor),
    createFormTypesGroups: asInteractor(CreateFormTypesGroupsInteractor),
    removeFormTypesGroups: asInteractor(RemoveFormTypesGroupsInteractor),
    showFormConfiguration: asInteractor(ShowFormConfigurationInteractor),
    createFormSection: asInteractor(CreateFormSectionInteractor),
    updateFormSection: asInteractor(UpdateFormSectionInteractor),
    getFormType: asInteractor(GetFormTypeInteractor),
    invalidateFormSection: asInteractor(InvalidateFormSectionInteractor),
    createAttribute: asInteractor(CreateAttributeInteractor),
    updateAttribute: asInteractor(UpdateAttributeInteractor),
    invalidateAttribute: asInteractor(InvalidateAttributeInteractor),
    createQualifier: asInteractor(CreateQualifierInteractor),
    updateQualifier: asInteractor(UpdateQualifierInteractor),
    invalidateQualifier: asInteractor(InvalidateQualifierInteractor),
    showLogin: asInteractor(ShowLoginInteractor),
    login: asInteractor(LoginInteractor),
    logout: asInteractor(LogoutInteractor),
    checkLoginStatus: asInteractor(CheckLoginStatusInteractor),
    loadUserPreferences: asInteractor(LoadUserPreferencesInteractor),
    changePassword: asInteractor(ChangePasswordInteractor),
    resetPassword: asInteractor(ResetPasswordInteractor),
    showSettings: asInteractor(ShowSettingsInteractor),
    showChangePassword: asInteractor(ShowChangePasswordInteractor),
    showResetPassword: asInteractor(ShowResetPasswordInteractor),
    createFormConfigSectionQualifier: asInteractor(
      CreateFormConfigSectionQualifierInteractor
    ),
    copyFormType: asInteractor(CopyFormTypeInteractor),
    showRegisteredApplicantDetails: asInteractor(
      ShowRegisteredApplicantDetailsInteractor
    ),
    showForms: asInteractor(ShowFormsInteractor),
    getReportingPeriodsByApplicantId: asInteractor(
      GetReportingPeriodsByApplicantIdInteractor
    ),
    getReportingPeriodFormTypes: asInteractor(
      GetReportingPeriodFormTypesInteractor
    ),
    showFrontOfficeHome: asInteractor(ShowFrontOfficeHomeInteractor),

    getAllRootMenuItems: asInteractor(GetAllRootMenuItemsInteractor),
    getAvailableMenuItems: asInteractor(GetAvailableMenuItemsInteractor),
    createMenuItem: asInteractor(CreateMenuItemInteractor),
    updateMenuItem: asInteractor(UpdateMenuItemInteractor),
    showMenuItems: asInteractor(ShowMenuItemsInteractor),
    showFormDetailsReport: asInteractor(ShowFormDetailsInteractor),
    getSystemParameters: asInteractor(GetSystemParametersInteractor),
    removeSystemParameters: asInteractor(RemoveSystemParametersInteractor),
    showSystemParameters: asInteractor(ShowSystemParametersInteractor),
    createSystemParameter: asInteractor(CreateSystemParameterInteractor),
    updateSystemParameter: asInteractor(UpdateSystemParameterInteractor),
    getFacts: asInteractor(GetFactsInteractor),
    showFacts: asInteractor(ShowFactsInteractor),
    createFact: asInteractor(CreateFactInteractor),
    updateFact: asInteractor(UpdateFactInteractor),
    getBusinessRules: asInteractor(GetBusinessRulesInteractor),
    showBusinessRules: asInteractor(ShowBusinessRulesInteractor),
    createBusinessRule: asInteractor(CreateBusinessRuleInteractor),
    updateBusinessRule: asInteractor(UpdateBusinessRuleInteractor),
    getFormDetails: asInteractor(GetFormDetailsInteractor),
    getFormVersions: asInteractor(GetFormVersionsInteractor),
    getReferenceValueList: asInteractor(GetReferenceValueListInteractor),
    changeFormAttribute: asInteractor(ChangeFormAttributeInteractor),
    sendFormVersion: asInteractor(SendFormVersionInteractor),
    deleteDraftVersionForm: asInteractor(DeleteDraftVersionFormInteractor),
    addRow: asInteractor(AddRowInteractor),
    deleteRow: asInteractor(DeleteRowInteractor),
    undoRowDelete: asInteractor(UndoRowDeleteInteractor),
    addNewDraftFormVersion: asInteractor(AddNewDraftFormVersionInteractor),
    getRuleGroupElements: asInteractor(GetRuleGroupElementsInteractor),
    getRuleGroups: asInteractor(GetRuleGroupsInteractor),
    showRuleGroups: asInteractor(ShowRuleGroupsInteractor),
    createRuleGroup: asInteractor(CreateRuleGroupInteractor),
    updateRuleGroup: asInteractor(UpdateRuleGroupInteractor),
    addBusinessRuleToRuleGroup: asInteractor(
      AddBusinessRuleToRuleGroupInteractor
    ),
    removeBusinessRuleFromRuleGroup: asInteractor(
      RemoveBusinessRuleFromRuleGroupInteractor
    ),
    getEvaluationTypes: asInteractor(GetEvaluationTypesInteractor),
    showEvaluationTypes: asInteractor(ShowEvaluationTypesInteractor),
    createEvaluationType: asInteractor(CreateEvaluationTypeInteractor),
    updateEvaluationType: asInteractor(UpdateEvaluationTypeInteractor),
    assignApplicantsToReportingPeriod: asInteractor(
      AssignApplicantsToReportingPeriodInteractor
    ),
    getRequestTypes: asInteractor(GetRequestTypesInteractor),
    showRequestTypes: asInteractor(ShowRequestTypesInteractor),
    createRequestType: asInteractor(CreateRequestTypeInteractor),
    updateRequestType: asInteractor(UpdateRequestTypeInteractor),
    getApplicantRequests: asInteractor(GetApplicantRequestsInteractor),
    getApplicantReportingPeriods: asInteractor(
      GetApplicantReportingPeriodsInteractor
    ),
    showPortalReportingPeriods: asInteractor(
      ShowPortalReportingPeriodInteractor
    ),
    showPortalFormDetails: asInteractor(ShowPortalFormDetailsInteractor),
    getReportingPeriodApplicants: asInteractor(
      GetReportingPeriodApplicantsInteractor
    ),
    getPortalForms: asInteractor(GetPortalFormsInteractor),
    loadMenuItems: asInteractor(LoadMenuItemsInteractor),
    showPortalHome: asInteractor(ShowPortalHomeInteractor),
    createRequest: asInteractor(CreateRequestInteractor),
    updateRequest: asInteractor(UpdateRequestInteractor),
    showInfoNotificationBox: asInteractor(ShowInfoNotificationBoxInteractor),
    showReportingPeriodDetails: asInteractor(
      ShowReportingPeriodDetailsInteractor
    ),
    getBoFormTypes: asInteractor(GetBoFormTypesInteractor),
    getBoFormVersions: asInteractor(GetBoFormVersionsInteractor),
    getEvaluations: asInteractor(GetEvaluationsInteractor),
    showReportingPeriodApplicantDocuments: asInteractor(
      ShowReportingPeriodApplicantDocumentsInteractor
    ),
    uploadDocument: asInteractor(UploadDocumentInteractor),
    updateDocument: asInteractor(UpdateDocumentInteractor),
    showApplicantFormDetails: asInteractor(ShowApplicantFormDetailsInteractor),
    markForAdditionalCheck: asInteractor(MarkForAdditionalCheckInteractor),
    updateStatusOfAdditionalCheck: asInteractor(
      UpdateStatusOfAdditionalCheckInteractor
    ),
    setFormVersionForAnnouncement: asInteractor(
      SetFormVersionForAnnouncementInteractor
    ),
    getIsSignedReportRequiredForAnnouncement: asInteractor(
      GetIsSignedReportRequiredForAnnouncementInteractor
    ),
    updateElectronicRegistryNumber: asInteractor(
      UpdateElectronicRegistryNumberInteractor
    ),
    getAuthorizedOperators: asInteractor(GetAuthorizedOperatorsInteractor),
    getRequests: asInteractor(GetRequestsInteractor),
    markRequestRead: asInteractor(MarkRequestReadInteractor),
    showRequests: asInteractor(ShowRequestsInteractor),
    updateBusinessRuleInRuleGroup: asInteractor(
      UpdateBusinessRuleInRuleGroupInteractor
    ),
    getDataReport5: asInteractor(GetDataReport5Interactor),
    changeLanguage: asInteractor(ChangeLanguageInteractor),
    showFormVersionEvaluations: asInteractor(
      ShowFormVersionEvaluationsInteractor
    ),
    executeReportEvaluation: asInteractor(ExecuteReportEvaluationInteractor),
    showEvaluationPage: asInteractor(ShowEvaluationPageInteractor),
    getEvaluationRuleGroups: asInteractor(GetEvaluationRuleGroups),
    getEvaluationBusinessRules: asInteractor(
      GetEvaluationBusinessRulesInteractor
    ),
    showReport5Page: asInteractor(ShowReport5PageInteractor),
    getDataReport4: asInteractor(GetDataReport4Interactor),
    getRiskCriteria: asInteractor(GetRiskCriteriaInteractor),
    showReport4Page: asInteractor(ShowReport4PageInteractor),
    validateForm: asInteractor(ValidateFormInteractor),
    showAttributeCodebook: asInteractor(ShowAttributeCodebookInteractor),
    getAttributeReferenceList: asInteractor(
      GetAttributeReferenceListInteractor
    ),
    releaseRuleGroupFromEvaluationType: asInteractor(
      ReleaseRuleGroupFromEvaluationTypeInteractor
    ),
    joinRuleGroupToEvaluationType: asInteractor(
      JoinRuleGroupToEvaluationTypeInteractor
    ),
    getEvaluationTypeRuleGroups: asInteractor(
      GetEvaluationTypeRuleGroupsInteractor
    ),
    getReport3Data: asInteractor(GetReport3DataInteractor),
    showReport3Page: asInteractor(ShowReport3PageInteractor),
    getReport2Data: asInteractor(GetReport2DataInteractor),
    showReport2Page: asInteractor(ShowReport2PageInteractor),
    addBONewDraftFormVersion: asInteractor(AddBONewDraftFormVersionInteractor),
    getDataReport8: asInteractor(GetDataReport8Interactor),
    showReport8Page: asInteractor(ShowReport8PageInteractor),
    checkRightOfAccessToData: asInteractor(CheckRightOfAccessToDataInteractor),
    updateAttributeReference: asInteractor(UpdateAttributeReferenceInteractor),
    createAttributeReference: asInteractor(CreateAttributeReferenceInteractor),
    deleteAttributeReferenceList: asInteractor(
      DeleteAttributeReferenceListInteractor
    ),
    getAttributeCodeList: asInteractor(GetAttributeCodeListInteractor),
    deleteAttributeReference: asInteractor(DeleteAttributeReferenceInteractor),
    showReport6Page: asInteractor(ShowReport6PageInteractor),
    joinEvaluationTypeToFormType: asInteractor(
      JoinEvaluationTypeToFormTypeInteractor
    ),
    removeEvaluationTypeFromFormType: asInteractor(
      RemoveEvaluationTypeFromFormTypeInteractor
    ),
    getFormTypeEvaluations: asInteractor(GetFormTypeEvaluationsInteractor),
    showVerificationPage: asInteractor(ShowVerificationPageInteractor),
    getReport6Data: asInteractor(GetReport6DataInteractors),
    getDataReport1: asInteractor(GetDataReport1Interactor),
    showReport1Page: asInteractor(ShowReport1PageInteractor),
    getFormTypeList: asInteractor(GetFormTypeListInteractor),
    getReport1FormVersionList: asInteractor(
      GetReport1FormVersionListInteractor
    ),
    getReport1Applicants: asInteractor(GetReport1ApplicantsInteractor),
    getApplicants: asInteractor(GetApplicantsInteractor),
    getReport8Applicants: asInteractor(GetReport8ApplicantsInteractor),
    getRoles: asInteractor(GetRolesInteractor),
    getDynamicQueries: asInteractor(GetDynamicQueriesInteractor),
    createDynamicQuery: asInteractor(CreateDynamicQueryInteractor),
    updateDynamicQuery: asInteractor(UpdateDynamicQueryInteractor),
    deleteDynamicQuery: asInteractor(DeleteDynamicQueryInteractor),
    showDynamicQueries: asInteractor(ShowDynamicQueriesInteractor),
    setFormalCheckStatus: asInteractor(SetFormalCheckStatusInteractor),
    getSelectedLanguage: asInteractor(GetSelectedLanguageInteractor),
    loadLanguages: asInteractor(LoadLanguagesInteractor),
    loadApplication: asInteractor(LoadApplicationInteractor),
    createNewFormVersion: asInteractor(CreateNewFormVersionInteractor),
    publishFormVersion: asInteractor(PublishFormVersionInteractor),
    cancelFormVersion: asInteractor(CancelFormVersionInteractor),
    getFormReport: asInteractor(GetFormReportInteractor),
    uploadSignedReport: asInteractor(UploadSignedReportInteractor),
    showPublicationsReportPage: asInteractor(
      ShowPublicationsReportPageInteractor
    ),
    getAdditionalEvaluationResult: asInteractor(
      GetAdditionalEvaluationResultInteractor
    ),
    updateAdditionalEvaluationResult: asInteractor(
      UpdateAdditionalEvaluationResultInteractor
    ),
    showUnauthorizedMsg: asInteractor(ShowUnauthorizedMsgInteractor),
    isAllowedRandomSelection: asInteractor(IsAllowedRandomSelectionInteractor),
    getSystemParameterNumber: asInteractor(GetSystemParameterNumberInteractor),
    selectForAdditionalCheck: asInteractor(SelectForAdditionalCheckInteractor),
    confirmAdditionalCheck: asInteractor(ConfirmAdditionalCheckInteractor),
    getReportingPeriodApplicantDocuments: asInteractor(
      GetReportingPeriodApplicantDocumentsInteractor
    ),
    assignReportingPeriodApplicantDocument: asInteractor(
      AssignReportingPeriodApplicantDocumentInteractor
    ),
    removeReportingPeriodApplicantDocument: asInteractor(
      RemoveReportingPeriodApplicantDocumentInteractor
    ),
    showReport7Page: asInteractor(ShowReport7PageInteractor),
    getFormStructure: asInteractor(GetFormStructureInteractor),
    getReport7Data: asInteractor(GetReport7DataInteractor),
    getFormConfigDetails: asInteractor(GetFormConfigDetailsInteractor),
    updateFormConfigSectionQualifier: asInteractor(
      UpdateFormConfigSectionQualifierInteractor
    ),
    createFormConfigQualifierAttribute: asInteractor(
      CreateFormConfigQualifierAttributeInteractor
    ),
    updateFormConfigQualifierAttribute: asInteractor(
      UpdateFormConfigQualifierAttributeInteractor
    ),
    registerApplicant: asInteractor(RegisterApplicantInteractor),
    getRegisteredApplicants: asInteractor(GetRegisteredApplicants),
    getPortalReportingPeriodApplicantDocuments: asInteractor(
      GetPortalReportingPeriodApplicantDocumentsInteractor
    )
  });

  return {
    resolve<T>(name: string) {
      return _container.resolve(name) as T;
    },
    registerValue(name: string, dependency: any) {
      _container.register(name, asValue(dependency));
    },
    createScope() {
      return _container.createScope();
    }
  } as IModuleContainer;
};

export default ModuleContainer;
